module.exports = __webpack_public_path__ + "img/CompScope_Bright_03.ee8b5172.png";